import { useRef, useState } from "react";
import isEmpty from "../../validation/is-empty";
import PropTypes from "prop-types";

/// props validation | SQ(javascript:S6774)
CustomComponent.propTypes = {
  htmlContent: PropTypes.string,
};
export function CustomComponent(props) {
  const { htmlContent } = props;
  if (isEmpty(htmlContent)) {
    return null;
  }

  return (
    <div>
      <HtmlRenderer htmlString={htmlContent} />
    </div>
  );
}

/// props validation | SQ(javascript:S6774)
HtmlRenderer.propTypes = {
  htmlString: PropTypes.string,
};
function HtmlRenderer({ htmlString }) {
  return <div dangerouslySetInnerHTML={{ __html: htmlString }} />;
}

CustomTooltip.propTypes = {
  tooltipIcon: PropTypes.array,
  tooltipHtml: PropTypes.array,
  iconText: PropTypes.string,
};
export function CustomTooltip(props) {
  const { tooltipIcon, tooltipHtml, iconText } = props;
  const triggerRef = useRef(null);
  const [tooltipStyle, setTooltipStyle] = useState({});
  const [showTooltip, setShowTooltip] = useState(false);

  if (!tooltipIcon || !tooltipHtml) {
    return null;
  }

  const handleMouseEnter = () => {
    if (triggerRef.current) {
      const rect = triggerRef.current.getBoundingClientRect();
      setTooltipStyle({
        position: "fixed",
        top: rect.bottom + 5,
        left: rect.left,
      });
    }
    setShowTooltip(true);
  };

  const handleMouseLeave = () => {
    setShowTooltip(false);
  };

  return (
    <div
      ref={triggerRef}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      className="c-tooltip-parent"
      role="tooltip"
    >
      {tooltipIcon}
      {showTooltip && (
        <div className="c-tooltip-dynamic-style" style={tooltipStyle}>
          {iconText && (
            <h5>
              <span className="tooltip-icon-text">
                {tooltipIcon} {iconText}
              </span>
            </h5>
          )}
          {tooltipHtml}
        </div>
      )}
    </div>
  );
}
